import collarDetails from './collarDetails';
import costDetails from './costDetails';
import costConfirmation from './costConfirmation';
import rawData from './rawData';
import productionData from './productionData';
import prescriptionData from './prescriptionData';
import outStock from './outStock';
import inStock from './inStock';
import materialsInStock from './materialsInStock';
import inAndOutStore from './inAndOutStore';
import materialsInAndOutStore from './materialsInAndOutStore';
import expenseDetail from './expenseDetail';
import settleSummary from './settleSummary';
import pdPeriod from './pdPeriod';
import productPrice from './productPrice';

export default {
  collarDetails,
  costDetails,
  rawData,
  costConfirmation,
  productionData,
  prescriptionData,
  outStock,
  inStock,
  materialsInStock,
  inAndOutStore,
  materialsInAndOutStore,
  expenseDetail,
  settleSummary,
  pdPeriod,
  productPrice,
};
